import React from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router";
import bagIcon from "../../../../img/Bag.png";
const vendor = "37cfbaa0cdd335e81abd4aba05c5e254";
const BillSummery = ({ bill }) => {
  const navigate = useNavigate();
  const cart = useSelector(
    (state) => state.user.cart?.filter((c) => c.vendorId === vendor)?.[0]?.cart
  );

  const continueToBuyHandler = () => {
    if (bill?.Total < 500) {
      toast.error("Minimum Order Value is ₹500", {
        duration: 3000,
        position: "bottom-center",
        style: {
          border: "1px solid #f88001",
          marginBottom: "4rem",
          color: "#f88001",
          fontWeight: "bold",
        },
      });

      return;
    }
    navigate("../../address");
  };

  return (
    <>
      <div className="bg-white card-wrap cartBillSummery">
        <div className="BS-imgdiv d-flex align-items-center sec-title">
          <img src={bagIcon} alt="titleImg" style={{ width: "18px" }} />
          <h2>Bill Summary</h2>
        </div>
        <ul className="billSummaryList">
          <li>
            {`Item Total(${cart?.length} items)`}
            <div className="ms-auto price">{`₹${bill?.MRP}`}</div>
          </li>
          <li>
            Packaging Fees{" "}
            <div className="badge badge-success ms-auto">Free</div>
          </li>
          <li>
            Delivery Fees{" "}
            <div className="badge badge-success ms-auto">Free</div>
          </li>
          <li className="list-subtotal">
            SUB TOTAL: <div className="ms-auto">{`₹${bill?.Total}`}</div>
          </li>
        </ul>
      </div>
      {/* ----------------------Place Order Btn--------------------- */}
      <div className="cart-bottom-sheet bg-white">
        <div className="d-flex align-items-center justify-content-between">
          <div className="card flex-row align-items-center card-bottom border-0">
            <img src={bagIcon} className="bagicon" alt="IconBag" />
            <div className="card-body p-0">
              <h3>Sub Total</h3>
              <div className="d-flex align-items-center">
                <h5>
                  <strong>{`₹${bill?.Total}`}</strong>
                  <del>{`₹${bill?.MRP}`}</del>
                </h5>
                {bill?.MRP !== bill?.Total && (
                  <span className="badge badge-success">{`Save ₹${bill?.saved}`}</span>
                )}
              </div>
            </div>
          </div>
          <button
            className="btn btn-orange morebtn"
            onClick={() => continueToBuyHandler()}
          >
            Continue to Buy
          </button>
        </div>
      </div>
    </>
  );
};

export default BillSummery;
